import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { OrderAppType } from "../../shared/helpers/helper.common";
import { CountryMaster } from "../../shared/models/country.model";
import { CoreService } from "../../shared/services/core.service";
import { LoginService } from "../../shared/services/login.service";
import { UserService } from "../../shared/services/user.service";
import { NgSelectModule } from "@ng-select/ng-select";
import { FormsModule } from "@angular/forms";
import { NgStyle, AsyncPipe, NgIf } from "@angular/common";
import { take } from "rxjs";
import { Merchant } from "src/app/shared/models/merchant";
@Component({
  selector: "app-popup-register",
  templateUrl: "./popup-register.component.html",
  styleUrls: ["./popup-register.component.scss"],
  standalone: true,
  imports: [NgStyle, FormsModule, NgSelectModule, AsyncPipe, NgIf],
})

// Import required modules and classes
export class PopupRegisterComponent implements OnInit {
  // Observable for Merchant data
  Merchant$ = this.coreService.Merchant$;

  currentMerchant: Merchant;
  // Array to store country data
  Country: CountryMaster[];
  // Variable to store the selected country
  selectedCountry: any;
  // String to store the dial code of the selected country
  dialcode: string = "";
  // Boolean flag to indicate if the user accepted the policy
  isPolicy: boolean = false;
  // Reference to the modal element
  modal;

  venuePrivacyModal: any;

  @Output() ClosePopup = new EventEmitter<boolean>();

  // Constructor to initialize class dependencies
  constructor(
    private _router: Router,
    private coreService: CoreService,
    private RegistrationService: LoginService,
    private userService: UserService,
  ) {}

  // Lifecycle hook: ngOnInit
  ngOnInit() {
    // Get the reference to the modal element
    this.modal = document.getElementById("registerTermsModal");
    this.venuePrivacyModal = document.getElementById("venuePrivacyModal");

    // Fetch country data from the coreService
    this.coreService.getCountry().subscribe((resp) => {
      if (resp.data) {
        // Store country data in the Country array
        this.Country = resp.data;

        // Subscribe to the Merchant$ observable to get data from the server
        this.coreService.Merchant$.subscribe((data) => {
          if (data) {
            this.currentMerchant = data;
          }
          if (data && data.address) {
            // Set the default merchant country code based on the address.country value
            let mycountry: CountryMaster = this.Country.find(
              (x) => x.name == data.address.country,
            );
            // if (mycountry) {
            //   this.selectedCountry = mycountry;
            //   this.dialcode = mycountry.dial_code;
            // }
          }
        });
      }
    });
  }

  // Method to handle the ValueChange event of the country dropdown
  ValueChange(country) {
    // Update the dialcode based on the selected country's dial_code
    this.dialcode = country.dial_code;
  }

  // Method to attempt user registration using the provided form data
  attempRegistration(Form) {
    if (!Form.valid) {
      return;
    }

    // Prepare the userInfo object with registration details
    var userInfo = {
      register_from: OrderAppType.webapp,
      first_name: Form.form.value.FirstName,
      last_name: Form.form.value.LastName,
      dial_code: this.dialcode,
      phone_number: Form.form.value.Mobile,
      password: Form.form.value.Password,
      email: Form.form.value.Email,
      phone_number_length: this.selectedCountry.contact_number_length,
    };

    // Call the registration service to perform user registration
    this.RegistrationService.registration(userInfo).subscribe(
      (resp) => {
        // Handle the response data after successful registration
        if (resp) {
          const data = resp?.data ?? resp;
          // Store user details in local storage and emit data using UserSub subject from coreService
          localStorage.setItem("currentUser", JSON.stringify(data));
          this.coreService.UserSub.next(data);

          if (data?.token && !data?.user) {
            this.userService.GetUserProfile().subscribe(
              (profile) => {
                const registeredUser = {
                  ...data,
                  user: profile?.user,
                  success: 1,
                };
                localStorage.setItem(
                  "currentUser",
                  JSON.stringify(registeredUser),
                );
                this.coreService.UserSub.next(registeredUser);
                this.ClosePopup.emit();
              },
              () => {
                this.ClosePopup.emit();
              },
            );
            return;
          }

          this.ClosePopup.emit();
        }
      },
      (error) => {
        console.log("THIS IS ERROR" + JSON.stringify(error));
        // Handle errors during registration
        if (error.status === 422) {
          alert(error?.error?.message || JSON.stringify(error?.error?.errors));
        } else {
          alert(error?.error?.message || JSON.stringify(error?.error?.errors));
        }
      },
    );
  }

  // Method to check the value of an event (used for debugging)
  checkValue(event: any) {}

  // onVenuePrivacyClick() {
  //   this.Merchant$.pipe(take(1)).subscribe((merchant) => {
  //     if (!merchant) return;

  //     if (
  //       merchant.privacy_policy_type === "external_privacy_policy_link" &&
  //       merchant.privacy_policy_type_code === 0
  //     ) {
  //       if (merchant?.privacy_policy_url?.length > 0) {
  //         window.open(merchant.privacy_policy_url, "_blank");
  //       } else {
  //         window.open("https://www.toodleglobal.com/privacy-policy/", "_blank");
  //       }

  //       return;
  //     }

  //     this.venuePrivacyModal.style.display = "block";
  //   });
  // }

  onVenuePrivacyClick() {
    this.Merchant$.pipe(take(1)).subscribe((merchant) => {
      if (!merchant) return;

      if (
        merchant.privacy_policy_type === "external_privacy_policy_link" &&
        merchant.privacy_policy_type_code === 0
      ) {
        if (merchant?.privacy_policy_url?.length > 0) {
          window.open(merchant.privacy_policy_url, "_blank");
        } else {
          window.open("https://www.toodleglobal.com/privacy-policy/", "_blank");
        }
        return;
      }

      const modal = document.getElementById("venuePrivacyModal");
      if (modal) {
        modal.style.display = "block";
      }
    });
  }

  shouldShowVenuePrivacy(merchant: any): boolean {
    console.log("THIS IS MERCHNTA" + JSON.stringify(merchant));
    if (!merchant) return false;

    // If NOT external → show
    if (merchant.privacy_policy_type !== "external_privacy_policy_link") {
      console.log("THIS IS MERCHNT IF");
      return true;
    }
    console.log(
      "THIS IS MERCHNT ELSE" +
        (merchant.privacy_policy_type_code === 0 &&
          !!merchant.privacy_policy_url &&
          merchant.privacy_policy_url.length > 0 &&
          merchant.privacy_policy_type === "external_privacy_policy_link"),
    );

    // If external → URL must exist & type code must be 0
    return (
      merchant.privacy_policy_type_code === 0 &&
      !!merchant.privacy_policy_url &&
      merchant.privacy_policy_url.length > 0 &&
      merchant.privacy_policy_type === "external_privacy_policy_link"
    );
  }

  // closeVenuePrivacy() {
  //   this.venuePrivacyModal.style.display = "none";
  // }
  closeVenuePrivacy() {
    const modal = document.getElementById("venuePrivacyModal");
    if (modal) {
      modal.style.display = "none";
    }
  }

  // Method to handle the PolicyPopup display and actions
  PolicyPopup(Action: number, event: any = null) {
    if (!this.modal) {
      this.modal = document.getElementById("registerTermsModal");
    }

    if (Action === 1) {
      if (event?.currentTarget?.checked && this.modal) {
        this.modal.style.display = "block";
      }
    } else if (Action === 2) {
      this.isPolicy = false;
      if (this.modal) {
        this.modal.style.display = "none";
      }
    } else if (Action === 3) {
      this.isPolicy = true;
      if (this.modal) {
        this.modal.style.display = "none";
      }
    }
  }

  close() {
    if (this.modal) {
      this.modal.style.display = "none";
    }
    // this.ClosePopup.emit();
  }

  get borderStyle(): string {
    const menuColor =
      this.currentMerchant?.webapp_settings?.menu_color ??
      this.currentMerchant?.menu_color;

    const borderColor =
      this.currentMerchant?.webapp_settings?.menu_border_color ??
      this.currentMerchant?.menu_border_color;

    const borderWidth =
      this.currentMerchant?.webapp_settings?.menu_border_width ??
      this.currentMerchant?.menu_border_width;

    const style =
      menuColor !== borderColor
        ? `${borderWidth}px solid ${borderColor}`
        : `${borderWidth}px solid`;

    return style;
  }

  get menuBorderColor(): string {

 const menuColor =
   this.currentMerchant?.webapp_settings?.menu_font_color_homepgae ??
   this.currentMerchant?.menu_font_color_homepgae;

    return menuColor;
  }
}
